'use client';
import { modalShow } from '@/components/private/actions/modal';

export default function DownloadLockedButton({ label, className, }: { label: string; className: string }) {
  return (
    <a className={className} style={{ cursor: `pointer`, }} onClick={() => modalShow(`locked-download`)}>
      {label}
    </a>
  );
}
